function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 16,
  fill: "black",
  fillOpacity: 0.05
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_12355_393039)"
}, React.createElement("path", {
  d: "M17 20L19 22L23 18",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M19.9989 11C22.3347 13.0666 25.3833 14.1426 28.4989 14C28.9524 15.543 29.0912 17.1615 28.907 18.7592C28.7227 20.3569 28.2192 21.9013 27.4263 23.3005C26.6333 24.6998 25.5672 25.9254 24.2913 26.9045C23.0154 27.8836 21.5556 28.5962 19.9989 29C18.4421 28.5962 16.9823 27.8836 15.7064 26.9045C14.4305 25.9254 13.3644 24.6998 12.5715 23.3005C11.7785 21.9013 11.275 20.3569 11.0907 18.7592C10.9065 17.1615 11.0453 15.543 11.4989 14C14.6144 14.1426 17.663 13.0666 19.9989 11Z",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_12355_393039"
}, React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(8 8)"
})));

var SvgSignUpIconLight = function SvgSignUpIconLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSignUpIconLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SignUpIcon_Light.b6e99634.svg";
export { ForwardRef as ReactComponent };